// extracted by mini-css-extract-plugin
export default {"stepper":"LadderGameStepper_stepper__3+3y4","target":"LadderGameStepper_target__rHW4d","trace":"LadderGameStepper_trace__BqOip"};